import { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'O que são os Cadernos de Campo Digitais da Vulpes?',
      answer: 'Os Cadernos de Campo Digitais são uma plataforma completa para registar e gerir todas as atividades da sua exploração agrícola de forma digital, substituindo os cadernos tradicionais em papel por uma solução prática, organizada e acessível a partir de qualquer dispositivo.'
    },
    {
      question: 'Como funciona o sistema de Rega Inteligente?',
      answer: 'O nosso sistema de Rega Inteligente utiliza sensores IoT para monitorizar a humidade do solo, condições meteorológicas e necessidades das culturas em tempo real. Com base nestes dados, o sistema automatiza a irrigação, optimizando o consumo de água e garantindo que as suas culturas recebem exatamente a quantidade necessária.'
    },
    {
      question: 'Quanto posso economizar com a solução de Energia Inteligente?',
      answer: 'Em média, os nossos clientes conseguem reduzir os custos energéticos em 20-35% através da monitorização em tempo real, identificação de desperdícios e recomendações automáticas de otimização. O retorno do investimento ocorre tipicamente entre 12 a 18 meses.'
    },
    {
      question: 'As soluções Vulpes funcionam offline?',
      answer: 'Sim! Os Cadernos de Campo Digitais possuem modo offline, permitindo registar atividades mesmo sem conexão à internet. Os dados são sincronizados automaticamente assim que a ligação for restabelecida.'
    },
    {
      question: 'Preciso de conhecimentos técnicos para usar as soluções Vulpes?',
      answer: 'Não! As nossas soluções foram desenhadas para serem intuitivas e fáceis de usar. Além disso, fornecemos formação completa, suporte técnico dedicado e documentação detalhada para garantir que tira o máximo partido da plataforma.'
    },
    {
      question: 'Como é feita a instalação dos sistemas?',
      answer: 'A nossa equipa técnica realiza toda a instalação e configuração dos equipamentos. Fazemos uma avaliação prévia da exploração, instalamos os sensores e dispositivos necessários, e garantimos que tudo está a funcionar perfeitamente antes de entregar o sistema.'
    },
    {
      question: 'Existe suporte técnico disponível?',
      answer: 'Sim, oferecemos suporte técnico completo por telefone, email e chat. A nossa equipa está disponível para ajudar com qualquer questão ou problema que possa surgir.'
    }
  ];

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section container">
      <h2>Perguntas Frequentes</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeIndex === index}
              aria-controls={`faq-answer-${index}`}
            >
              <span>{faq.question}</span>
              <span className="faq-icon" aria-hidden="true">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div
              id={`faq-answer-${index}`}
              className="faq-answer"
              role="region"
              aria-labelledby={`faq-question-${index}`}
            >
              <div className="faq-answer-content">
                <p>{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
